module.exports = __webpack_public_path__ + "img/bn04.b1cd02a4.jpg";